import cx from 'classnames';
import { BZ2_REMOVED_BUYERS, BZ2_RESTORE_BUYER } from 'mk/autogenerated/translations/ClosedBuyers.22c0bbd8adc8cecdb2f62dc118a1251c'
import { BuyerEntity } from 'mk2/apps/bazaar/schemas';
import { AvatarImg } from 'mk2/components/AvatarImg';
import { Btn, BtnType } from 'mk2/components/Btn';
import { Panel } from 'mk2/components/Panel';
import useEventCallback from 'mk2/hooks/useEventCallback';
import React from 'react';
import styles from './ClosedBuyers.mscss';

interface OwnProps {
    className?: string;
    buyers: BuyerEntity[];

    onRestore(id: number);
}

type Props = OwnProps;

const ClosedBuyers: React.FunctionComponent<Props> = ({ className, buyers, onRestore }) => {
    return (
        <Panel className={cx(styles.ClosedBuyers, className)}>
            <div className={styles.ClosedBuyers__title}>{BZ2_REMOVED_BUYERS}</div>
            <div className={styles.ClosedBuyers__list}>
                {buyers.map((buyer) => (
                    <ClosedBuyer key={buyer.id} buyer={buyer} onRestore={onRestore} />
                ))}
            </div>
        </Panel>
    );
};

ClosedBuyers.displayName = 'ClosedBuyers';

export default React.memo<Props>(ClosedBuyers);

interface ClosedBuyerOwnProps {
    className?: string;
    buyer: BuyerEntity;

    onRestore(id: number);
}

let ClosedBuyer: React.FunctionComponent<ClosedBuyerOwnProps> = ({ className, buyer, onRestore }) => {
    const onRestoreCallback = useEventCallback(
        (event: React.MouseEvent<HTMLAnchorElement>) => {
            event.preventDefault();
            onRestore(buyer.id);
        },
        [onRestore, buyer],
    );

    return (
        <div className={cx(styles.ClosedBuyer, className)}>
            <Btn
                className={styles.ClosedBuyer__button}
                type={BtnType.BlueOutline}
                onClick={onRestoreCallback}
                label={
                    <span className={styles.ClosedBuyer__button__content}>
                        <AvatarImg className={styles.ClosedBuyer__avatar} user={buyer.user} size={16} />
                        <strong className={styles.ClosedBuyer__username}>{buyer.user.username}</strong>
                        <span className={styles.ClosedBuyer__restore}>{BZ2_RESTORE_BUYER}</span>
                    </span>
                }
            />
        </div>
    );
};

ClosedBuyer.displayName = 'ClosedBuyer';
ClosedBuyer = React.memo<ClosedBuyerOwnProps>(ClosedBuyer);
